<template>
    <div>
        <div class="container pb-3" v-if="campaign != null">
            <campaign-picture :arrCampaignImage="campaign.pictures"></campaign-picture>
            <div class="box-detail-content">
                
                <div class="content-header">{{ campaign.name }}</div>
                <div class="expire">ใช้ได้ถึง : {{dateExpire}}</div>
                <div class="line-expire"></div>
                <div class="detail" v-html="campaignDetail"></div>

                 <redeem class=""
                    :lbl="lbl"
                    :campaign="campaign"
                    :selectedId="campaignId"
                    :selectedPoint="point"
                    :selectedQuantity="quantity"
                    @updateCampaignInfo="updateCampaignInfo($event)"
                    ></redeem>
            </div>
           
            
        </div>
    </div>
</template>
<script>
import Datetime from "@/helper/DatetimeHelper.js";
import CampaignPicture from "@/components/campaign/detail/Picture.vue";
//import DetailAndCondition from "@/components/campaign/detail/DetailAndCondition";
//import SubCampaignDropdown from '@/components/campaign/detail/SubCampaignDropDown.vue';
import Redeem from "@/components/campaign/detail/Redeem.vue";
import Util from '@/helper/Utility.js';
/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {number} locale (required) Current language.
 * @property {object} campaign (required) Campaign information.
 * Method
 * @method initialLayout Setup campaign information.
 * @method updateSelectedCampaignInfo Callback for subcampagin to update Campaign information.
 */
export default {
    name: "DefaultLayout",
    components: {
        CampaignPicture,
        //DetailAndCondition,
        //SubCampaignDropdown,
        Redeem
    },
    props: {
        lbl: Object,
        locale: Number,
        campaign: Object,
    },
    data: function() {
        return {
            campaignId: '',
            quantity: 0,
            point: 0,
            price: 0,
            originPrice: 0,
            discount: 0,
            dateExpire: "",
            campaignDetail: "",

            isShowSubcampaign: false,
            subCampaign: null,
        };
    },
    created: function () {
        console.log("default");
        this.initialLayout();
    },
    methods: {
        initialLayout: function () {
             this.campaignDetail = Util.newLineToBr(this.campaign.detail);
            if(this.campaign.subCampaignStyles) {
                this.isShowSubcampaign = true;
                this.subCampaign = this.campaign.subCampaignStyles.styles;
                
                var firstsubcampaign = this.campaign.subCampaignStyles.styles[0];
                if(firstsubcampaign.subitems[0].value != 'none') firstsubcampaign = firstsubcampaign.subitems[0];
                
                this.updateSelectedCampaignInfo(firstsubcampaign);
            } else {
                this.updateSelectedCampaignInfo();
            }

            this.dateExpire = Datetime.dateDetailFormat(this.campaign.expireDate);
        },
        getPointText: function () {
            var pointTypeTxt = this.campaign.pointType && this.campaign.pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            var point = this.locale === 1033 && this.point > 1
                        ? this.lbl.detail.point + 's'
                        : this.lbl.detail.point;

            return pointTypeTxt + this.point + ' ' + point;
        },            
        updateCampaignInfo: function (campaign) {
            this.campaign.updateCampaign(campaign);
            this.initialLayout();
        },
        updateSelectedCampaignInfo: function (selectedItem) {
            if(selectedItem) {
                this.campaignId  = selectedItem.campaignId;
                this.quantity = selectedItem.quantity - (selectedItem.itemCountSold || 0);
                this.point = selectedItem.points || selectedItem.point || 0;
                this.price = selectedItem.price;
                this.originalPrice = selectedItem.originalPrice;
                this.discount = selectedItem.discount;
            } else {
                this.campaignId = this.campaign.id;
                this.quantity = this.campaign.qty;
                this.point = this.campaign.pointPerUnit;
                this.price = this.campaign.pricePerUnit;
                this.originalPrice = this.campaign.originalPrice;
                this.discount = this.campaign.discount;
            }
        }
    }
};
</script>
<style lang="scss">

</style>
<style lang="scss" scoped>
    .box-detail-content {
        background-color: #fff;
        padding: 15px;
        min-height: 50vh;
        // min-height: calc(100vh - 87px);
        position: relative;

        .content-header {
            text-align: center;
            font-size: 1rem;
            line-height: 1.3;
            margin: 15px 0 5px 0;
            font-weight: bold;

            @media screen and (max-width: 325px) {
                font-size: 0.9rem;
            }
        }

        .line-expire{
            height: 2px;
            background-color:#151515 ; 
            width: 50%;
            margin: auto;
        }
        .redeem-btn-wrapper {
            position: relative;
            // min-height: 23vh;
        }
        .detail {
            margin-top: 15px;
            font-size: 0.9rem;
            text-align: center;
            padding: 0 30px;
            padding-bottom: 110px;

            @media screen and (max-width: 325px) {
                font-size: 0.8rem;
            }
        }

        .expire {
            font-size: 0.9rem;
            text-align: center;
            margin: 5px 0 15px 0;
        }
    
    }
</style>
